import { servicePayments } from "../servicePayments";
import { ListRequestQuery } from "../../utils/serviceHelper";
import {
  IRequirementDefinitionResponse,
  RequirementType
} from "@wingspanhq/payments/dist/interfaces";
import { RequirementDefinitionStatus } from "@wingspanhq/payments/dist/interfaces/requirement";

export interface RequirementDefinitionFilter {
  status?: RequirementDefinitionStatus | { in?: RequirementDefinitionStatus[] };
  type?: RequirementType;
}

export type RequirementDefinitionListResponse = {
  data: IRequirementDefinitionResponse[];
  summary: {
    listSize: number;
  };
};

export const listRequirementDefinitions = async (
  params?: ListRequestQuery<
    RequirementDefinitionFilter,
    {
      createdAt?: "asc" | "desc";
    }
  >
): Promise<RequirementDefinitionListResponse> => {
  const { data, headers } = await servicePayments.get(
    `/requirement-definition`,
    {
      params
    }
  );

  return { summary: { listSize: Number(headers["x-ws-list-size"]) }, data };
};
